import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { RoleGuard } from './shared/guards/role.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'floor-plan',
    loadChildren: () => import('./floor-plan/floor-plan.module').then(m => m.FloorPlanModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'menu',
    loadChildren: () => import('./modules/menu/menu.module').then(m => m.MenuModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'orders',
    loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'kitchen',
    loadChildren: () => import('./modules/kitchen/kitchen.module').then(m => m.KitchenModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./modules/billing/billing.module').then(m => m.BillingModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'insumos',
    loadChildren: () => import('./modules/insumos/insumos.module').then(m => m.InsumosModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: 'configuracion',
    loadChildren: () => import('./configuracion/configuracion.module').then(m => m.ConfiguracionModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  // Vista pública por código QR (sin login): estado de la mesa solo si tiene pedido activo no facturado
  {
    path: 'p/table-status',
    loadChildren: () => import('./modules/qr-client/qr-client.module').then(m => m.QrClientModule)
  },
  { path: 'qr-client', redirectTo: 'dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
